angular.module('env.uiRouter', [])

    .config(function config($urlRouterProvider) {
        $urlRouterProvider.when('/logout', ['$state', 'authService', function ($state, authService) {
            if (authService.isAuthorized()) {
                authService.logout().then(function () {
                    $state.go('login');
                });
                return;
            }
            $state.go('login');
        }]);

        $urlRouterProvider.otherwise('/client/home');
    })

    .run(function ($rootScope, $state, $log, authService, cookiesService, usersRepository, gettextCatalog, toastr, appLocale) {
        var stateBeforeLogin;

        authService.events.on('authenticationRequiredAfterReload', function () {
            //$state.go('login');
        });

        authService.events.on('continueSessionAfterReload', function () {
            //$state.go('client.home');
        });

        //On login check if we need a user to redirect to the profile view
        //to fill-in missing information
        //Also show Cookies policy message if necessary
        authService.events.on('login', function () {

            //We have to show cookies warning but only after the app locales loaded
            //to make sure the warning will be translated
            appLocale.loading.ensureLoaded()
                .then(function () {
                    cookiesService.showCookiesPolicyMessage();
                });

            usersRepository.getCurrentUser().then(function (user) {
                if (user && !user.isValid()) {
                    $state.go('client.userprofile');
                    toastr.warning('It is missing some important information', gettextCatalog.getString('Your profile is incomplete'));
                }
            });
        });

        $rootScope.$on('$stateNotFound',
            function (event, unfoundState, fromState, fromParams) {
                $log.error("Can't found state '%s'", unfoundState);
            }
        );

        $rootScope.$on('$stateChangeError',
            function (event, toState, toParams, fromState, fromParams, error) {
                $log.error("Can't navigate to the route '%s'", toState.name, error);
            }
        );

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            var isAuth = authService.isAuthorized();

            // Some code to redirect user to the state he was going to prior to authentication
            if (fromState.name == 'login' && isAuth && stateBeforeLogin && toState.name != stateBeforeLogin.name) {
                event.preventDefault();
                $state.go(stateBeforeLogin.name, stateBeforeLogin.params);
                stateBeforeLogin = null;
                return;
            }

            // Some code to prevent "manual" navigation to login page when we are authorised
            if (toState.name == 'login' && isAuth) {
                event.preventDefault();
                $state.go('client.home');
                return;
            }

            // Some code to prevent "manual" navigation through routes when we weren't authorised
            if (toState.name != 'login' && toState.name != 'passwordReset' && toState.name != 'signup' && !isAuth) {
                event.preventDefault();
                stateBeforeLogin = {
                    name: toState.name,
                    params: toParams
                };
                if (fromState.name != 'login') {
                    $state.go('login');
                }
                return;
            }
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            $log.debug("UI state changed from '%s' to '%s'", fromState.name, toState.name);
            if (toState.data && toState.data.pageTitle) {
                $rootScope.pageTitle = gettextCatalog.getString(toState.data.pageTitle);
            }
            $state.previous = (fromState && fromState.name) ? fromState.name : null;
        });
    })

;
